export default "__VITE_ASSET__Bpe36XSB__"